"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ForbiddenError extends client_library_1.ExtendableError {
    constructor() {
        super('Forbidden');
    }
}
exports.default = ForbiddenError;
//# sourceMappingURL=ForbiddenError.js.map